import {
  ScreenActivity,
  ActivityModel
} from '../../models/activities/activity';
import { EmailFooter } from '../email-footer';
import { ApplicationLogEmailVM, EmailAttachment } from '../log-email';
import { Role } from '../role';

export class EmailActivityModel extends ActivityModel {
  to: string[] = [];
  cc: string[] = [];
  bcc: string[] = [];
  roles: Role[] = [];
  body: string;
  subject: string;
  attachments: EmailActivityAttachment[] = [];
  emailApplicant: boolean;
  requestReadReceipt: boolean;
  customFromAddress: string;
  allowCustomFromAddress: boolean;
  availableFooters: EmailFooter[];
  emailFooterId?: string;

  constructor(options?: Partial<EmailActivityModel>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class EmailActivityAttachment extends EmailAttachment {
  activityId: string;
  deTemplateCode: string;
}

export class EmailActivity<
  T extends EmailActivityModel = EmailActivityModel
> extends ScreenActivity<EmailActivityModel> {
  applicationEmails: EmailActivityLogEmailVM[];
  showResendEmails: boolean;

  constructor(options?: Partial<EmailActivity<T>>) {
    super(options);

    this.model = new EmailActivityModel();
    if (options) {
      Object.assign(this, options);
    }

    this.model = new EmailActivityModel(options ? options.model : null);

    this.model.screenName = this.model.screenName || 'Email';
  }

  public displayOnScreen(): boolean {
    return false;
  }
}

export class EmailActivityLogEmailVM extends ApplicationLogEmailVM {
  emailApplicant: boolean;
}